import { WizardSteps } from "../../components/wizard/WizardStepper";

export const SignupSteps: WizardSteps = [
  { name: "Create account" },
  { name: "Setup profile" },
  { name: "Setup property" },
];
